import { MantineThemeColors, Space, Table, useMantineTheme } from '@mantine/core';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface StyledTableProps {
  dark?: boolean;
  colors: MantineThemeColors;
}

const StyledTable = styled(Table)<StyledTableProps>`
  thead {
    tr {
      th {
        color: ${({ dark }) => (dark ? 'white' : 'black')};
        font-weight: normal;
        border-bottom: 2px solid ${({ dark, colors }) => (dark ? colors.dark[6] : colors.gray[2])} !important;
        padding-bottom: 15px;
      }
    }
  }
  tbody {
    margin-top: 100px;
    tr:nth-child(2n) {
      background-color: ${({ dark, colors }) => (dark ? colors.dark[7] : colors.gray[0])};
    }
    tr {
      &:hover {
        background-color: ${({ dark, colors }) => (dark ? colors.dark[6] : colors.gray[1])};
      }
      height: 40px;
      td {
        font-weight: 300;
        border: none;
      }
    }
  }
`;

const BookitupTable: FC<{ children: ReactNode }> = ({ children }) => {
  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  return (
    <StyledTable dark={darkMode} colors={colors}>
      <Space h="sm" />
      {children}
    </StyledTable>
  );
};

export default BookitupTable;
